<template>
  <div class="flex flex-col items-end mt-1 w-full mx-auto">
    <section class="bg-gray-300 p-6 w-full" :aria-label="$t('stripe.data')">
      <input class="w-full py-2 pl-2 outline-none" :placeholder="$t('stripe.holder')" v-model="cardHolder" />
      <div class="bg-white py-3 mt-4" id="card-element" ref="card"></div>

      <div class="flex justify-center mt-8">
        <button id="card-button" class="border shadow-md p-4 bg-white text-sm hover:text-white hover:bg-b2c-red-300 rounded"
        @click="savePaymentMethod()" :class="isLoading ? 'loader' : ''">
          {{ $t('stripe.save') }}
        </button>
      </div>

    </section>

  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

// eslint-disable-next-line no-undef
const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
let card = null;

export default {
  props: ['intent'],

  data() {
    return {
      cardHolder: '',

      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      customer: ['auth/customer'],
      changedLocale: 'auth/changedLocale',
    }),
  },

  watch: {
    changedLocale() {
      this.displayCard();
    },
  },

  mounted() {
    this.displayCard();
  },

  beforeDestroy() {
    card.destroy(this.$refs.card);
  },

  methods: {
    displayCard() {
      const elements = stripe.elements({
        locale: this.$i18n.locale,
      });
      card = elements.create('card');

      card.mount(this.$refs.card);
    },

    savePaymentMethod() {
      this.isLoading = true;
      stripe.confirmCardSetup(
        this.intent.client_secret, {
          payment_method: {
            card,
            billing_details: { name: this.cardHolder },
          },
        },
      ).then((result) => {
        if (result.error) {
          this.isLoading = false;
          this.createNotification('error', result.error.message);
          return;
        }
        axios.post(`/api/customers/${this.customer.id}/update-payment-method`, { payment_method: result.setupIntent.payment_method }).then(() => {
          this.$emit('updated-payment-method');
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          this.checkSessionErrorNotification(error);
        });
      });
    },
  },

};
</script>

<style lang="scss" scoped>
.loader {
  color: transparent !important;
  pointer-events: none;
  position: relative;
}

.loader:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #dbdbdb;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
